import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { ownerContributorAndViewerIds } from 'src/components/form';
import { useI18NSummaryHelpContent } from 'src/components/help-panel/useSummaryHelpContent';
import { useInsertInternalAudit } from 'src/hooks/mutations/internal-audit';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import {
  internalAuditDetailsUrl,
  internalAuditRegisterUrl,
} from '@/utils/urls';

import InternalAuditForm from '../../forms/InternalAuditForm';
import type { InternalAuditFormDataFields } from '../../forms/internalAuditSchema';

const InternalAuditCreateTab: FC = () => {
  useI18NSummaryHelpContent('internalAudits.help');
  const navigate = useNavigate();
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');

  const { insertInternalAudit } = useInsertInternalAudit();

  const onSave = async (variables: InternalAuditFormDataFields) => {
    const data = await insertInternalAudit({
      Title: variables.Title,
      Description: variables.Description ?? '',
      BusinessArea: variables.BusinessArea ?? '',
      CustomAttributeData: variables.CustomAttributeData || undefined,
      ...ownerContributorAndViewerIds(variables),
      DepartmentTypeIds:
        variables.departments?.map((d) => d.DepartmentTypeId) || [],
      TagTypeIds: variables.tags?.map((t) => t.TagTypeId) || [],
    });
    if (data?.insertInternalAudit?.Id) {
      navigate(internalAuditDetailsUrl(data?.insertInternalAudit?.Id));
    }

    return { savedId: data?.insertInternalAudit?.Id };
  };

  const onDismiss = (saved?: boolean) => {
    if (!saved) {
      navigate(internalAuditRegisterUrl());
    }
  };

  return (
    <>
      <InternalAuditForm
        onSave={onSave}
        onDismiss={onDismiss}
        publishToolbarState={objectToolbarEnabled}
      />
    </>
  );
};

export default InternalAuditCreateTab;
